import { render, staticRenderFns } from "./settlement-drawer-factory.vue?vue&type=template&id=82ca68ba&scoped=true"
import script from "./settlement-drawer-factory.vue?vue&type=script&lang=js"
export * from "./settlement-drawer-factory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82ca68ba",
  null
  
)

export default component.exports